/** App Container actions */
export enum AppAction {
    InitStore = 'PATHFINDER/APP/INIT_STORE',
    StartLoading = 'PATHFINDER/APP/START_LOADING',
    StopLoading = 'PATHFINDER/APP/STOP_LOADING',
    SetError = 'PATHFINDER/APP/SET_ERROR',
    StepToNextLevel = 'PATHFINDER/APP/STEP_TO_NEXT_LEVEL',
    StepBack = 'PATHFINDER/APP/STEP_BACK',
}

/** Error types */
export enum ErrorType {
    CmsConfig = 'CMS Config error',
}
